export default __webpack_public_path__ + "static/media/homeless.539ff6e4.jpg";